module.exports = __webpack_public_path__ + "img/background.5f51605b.png";